(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("analytics", [], factory);
	else if(typeof exports === 'object')
		exports["analytics"] = factory();
	else
		root["analytics"] = factory();
})(self, () => {
return 